export enum Locale {
  af = 'Afrikaans',
  ar = 'Arabic',
  az = 'Azeri (Latin)',
  bg = 'Bulgarian',
  bn = 'bn',
  bs = 'bs',
  ca = 'Catalan',
  chr = 'chr',
  cs = 'Czech',
  da = 'Danish',
  de = 'German',
  el = 'Greek',
  en = 'English',
  en_AU = 'English (Australia)',
  en_CA = 'English (Canada)',
  en_GB = 'English (United Kingdom)',
  es = 'Spanish',
  eu_ES = 'Basque (Spain)',
  fa = 'Farsi',
  fa_IR = 'Farsi (Iran)',
  fi = 'Finnish',
  fr = 'French',
  gl = 'Galician',
  gu = 'Gujarati',
  ha = 'ha',
  hi = 'Hindi',
  hr = 'Croatian',
  hu = 'Hungarian',
  ig = 'ig',
  in = 'in',
  it = 'Italian',
  iw = 'iw',
  ja = 'Japanese',
  ka = 'Georgian',
  kab = 'kab',
  kk = 'Kazakh',
  kn = 'Kannada',
  ko = 'Korean',
  lt = 'Lithuanian',
  mk = 'FYRO Macedonian',
  ml = 'ml',
  ml_IN = 'Malayalam',
  ms = 'Malay',
  nl = 'Dutch',
  no = 'no',
  pa_IN = 'Punjabi (India)',
  pl = 'Polish',
  ps = 'Pashto',
  pt = 'Portuguese',
  pt_BR = 'Portuguese (Brazil)',
  ro = 'Romanian',
  ru = 'Russian',
  sd = 'sd',
  si = 'si',
  sk = 'Slovak',
  sl = 'Slovenian',
  sq = 'Albanian',
  sr = 'sr',
  sr_CS = 'Serbian (Latin)',
  sr_SP = 'Serbian (Cyrillic) (Serbia and Montenegro)',
  sv = 'Swedish',
  sw = 'Swahili',
  ta = 'Tamil',
  te = 'Telugu',
  th = 'Thai',
  tl = 'Tagalog',
  tr = 'Turkish',
  tw = 'tw',
  uk = 'Ukrainian',
  ur = 'Urdu',
  uz = 'Uzbek (Latin)',
  vi = 'Vietnamese',
  yo_NG = 'yo_NG',
  zh_CN = 'Chinese (S)',
  zh_TW = 'Chinese (T)'
}
